// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeeDemographicsBreakdownRecordDto
 */
export interface IEmployeeDemographicsBreakdownRecordDto {
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    date_of_birth?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    ee_provided_email?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    er_provided_email?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    ee_provided_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    er_provided_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    employment_status?: string;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    employment_status_effective_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    physical_address_line1?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    physical_address_line2?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    physical_city?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    physical_state?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    physical_zipcode?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    mailing_address_line1?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    mailing_address_line2?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    mailing_city?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    mailing_state?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    mailing_zipcode?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    distributor_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    employer_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    subsidiary_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {number}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IEmployeeDemographicsBreakdownRecordDto
     */
    custom_field_name_to_value?: { [key: string]: string; };
}

/**
 * Check if a given object implements the IEmployeeDemographicsBreakdownRecordDto interface.
 */
export function instanceOfIEmployeeDemographicsBreakdownRecordDto(value: object): value is IEmployeeDemographicsBreakdownRecordDto {
    return true;
}

export function IEmployeeDemographicsBreakdownRecordDtoFromJSON(json: any): IEmployeeDemographicsBreakdownRecordDto {
    return IEmployeeDemographicsBreakdownRecordDtoFromJSONTyped(json, false);
}

export function IEmployeeDemographicsBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeDemographicsBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date_of_birth': json['date_of_birth'] == null ? undefined : (new Date(json['date_of_birth'])),
        'ee_provided_email': json['ee_provided_email'] == null ? undefined : json['ee_provided_email'],
        'er_provided_email': json['er_provided_email'] == null ? undefined : json['er_provided_email'],
        'ee_provided_phone': json['ee_provided_phone'] == null ? undefined : json['ee_provided_phone'],
        'er_provided_phone': json['er_provided_phone'] == null ? undefined : json['er_provided_phone'],
        'employment_status': json['employment_status'] == null ? undefined : json['employment_status'],
        'employment_status_effective_date': json['employment_status_effective_date'] == null ? undefined : (new Date(json['employment_status_effective_date'])),
        'physical_address_line1': json['physical_address_line1'] == null ? undefined : json['physical_address_line1'],
        'physical_address_line2': json['physical_address_line2'] == null ? undefined : json['physical_address_line2'],
        'physical_city': json['physical_city'] == null ? undefined : json['physical_city'],
        'physical_state': json['physical_state'] == null ? undefined : json['physical_state'],
        'physical_zipcode': json['physical_zipcode'] == null ? undefined : json['physical_zipcode'],
        'mailing_address_line1': json['mailing_address_line1'] == null ? undefined : json['mailing_address_line1'],
        'mailing_address_line2': json['mailing_address_line2'] == null ? undefined : json['mailing_address_line2'],
        'mailing_city': json['mailing_city'] == null ? undefined : json['mailing_city'],
        'mailing_state': json['mailing_state'] == null ? undefined : json['mailing_state'],
        'mailing_zipcode': json['mailing_zipcode'] == null ? undefined : json['mailing_zipcode'],
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'distributor_external_identifier': json['distributor_external_identifier'] == null ? undefined : json['distributor_external_identifier'],
        'employer_external_identifier': json['employer_external_identifier'] == null ? undefined : json['employer_external_identifier'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_external_identifier': json['subsidiary_external_identifier'] == null ? undefined : json['subsidiary_external_identifier'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'custom_field_name_to_value': json['custom_field_name_to_value'] == null ? undefined : json['custom_field_name_to_value'],
    };
}

export function IEmployeeDemographicsBreakdownRecordDtoToJSON(json: any): IEmployeeDemographicsBreakdownRecordDto {
    return IEmployeeDemographicsBreakdownRecordDtoToJSONTyped(json, false);
}

export function IEmployeeDemographicsBreakdownRecordDtoToJSONTyped(value?: IEmployeeDemographicsBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date_of_birth': value['date_of_birth'] == null ? undefined : ((value['date_of_birth']).toISOString().substring(0,10)),
        'ee_provided_email': value['ee_provided_email'],
        'er_provided_email': value['er_provided_email'],
        'ee_provided_phone': value['ee_provided_phone'],
        'er_provided_phone': value['er_provided_phone'],
        'employment_status': value['employment_status'],
        'employment_status_effective_date': value['employment_status_effective_date'] == null ? undefined : ((value['employment_status_effective_date']).toISOString().substring(0,10)),
        'physical_address_line1': value['physical_address_line1'],
        'physical_address_line2': value['physical_address_line2'],
        'physical_city': value['physical_city'],
        'physical_state': value['physical_state'],
        'physical_zipcode': value['physical_zipcode'],
        'mailing_address_line1': value['mailing_address_line1'],
        'mailing_address_line2': value['mailing_address_line2'],
        'mailing_city': value['mailing_city'],
        'mailing_state': value['mailing_state'],
        'mailing_zipcode': value['mailing_zipcode'],
        'partner_external_identifier': value['partner_external_identifier'],
        'partner_name': value['partner_name'],
        'distributor_external_identifier': value['distributor_external_identifier'],
        'employer_external_identifier': value['employer_external_identifier'],
        'employer_name': value['employer_name'],
        'subsidiary_external_identifier': value['subsidiary_external_identifier'],
        'subsidiary_name': value['subsidiary_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'employee_id': value['employee_id'],
        'custom_field_name_to_value': value['custom_field_name_to_value'],
    };
}

